import { SpotlightItem, SpotlightItemType } from '@thoughtspot/global-nav';
import { useTranslation } from '@thoughtspot/i18n';
import { IconID } from '@thoughtspot/radiant-react/widgets/icon';
import {
    canCreateOrEditConnections,
    isConvAssistEnabled,
    isFoldersEnabled,
} from '@thoughtspot/session-service';
import { useMemo } from 'react';
import { routePaths } from '../../routing/routes-util';

/**
 * Returns the static Create items matching the home-left-panel create menu:
 * Create Liveboard, Create Answer, Create Collection (if folders enabled),
 * New Spotter chat, and New Connection (if user has connection privileges).
 */
export function useSpotlightCreateItems(): SpotlightItem[] {
    const { t } = useTranslation();
    return useMemo(
        () => [
            ...(isConvAssistEnabled()
                ? [
                      {
                          id: 'create-filter-spotter-chat',
                          label: t(
                              'navigationhub.home.navpanel.create.spotterChat',
                          ),
                          icon: IconID.SPOTTER,
                          type: SpotlightItemType.CREATE,
                          path: routePaths.ConvAssist,
                          keywords: ['create', 'spotter', 'chat', 'new', 'ai'],
                      },
                  ]
                : []),
            {
                id: 'create-filter-liveboard',
                label: t('navigationhub.home.navpanel.create.liveboard'),
                icon: IconID.PLUS,
                type: SpotlightItemType.CREATE,
                path: routePaths.Pinboards,
                keywords: ['create', 'liveboard', 'new'],
            },
            {
                id: 'create-filter-answer',
                label: t('navigationhub.home.navpanel.create.answer'),
                icon: IconID.PLUS,
                type: SpotlightItemType.CREATE,
                path: '/insights/answer',
                keywords: ['create', 'answer', 'new'],
            },
            ...(isFoldersEnabled()
                ? [
                      {
                          id: 'create-filter-collection',
                          label: t(
                              'navigationhub.home.navpanel.create.collection',
                          ),
                          icon: IconID.PLUS,
                          type: SpotlightItemType.CREATE,
                          path: routePaths.Home,
                          keywords: ['create', 'collection', 'new', 'folder'],
                      },
                  ]
                : []),
            ...(canCreateOrEditConnections()
                ? [
                      {
                          id: 'create-filter-connection',
                          label: t(
                              'navigationhub.home.navpanel.create.connection',
                          ),
                          icon: IconID.PLUS,
                          type: SpotlightItemType.CREATE,
                          path: routePaths.EmbraceConnection,
                          keywords: [
                              'create',
                              'connection',
                              'new',
                              'embrace',
                              'data source',
                          ],
                      },
                  ]
                : []),
        ],
        [t],
    );
}
